TS.ns('WL');

WL.documentTypeChecklistModel = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var documenttypeChecklistList = me.getDomainProperty('grdDocumentCheckList_Property');
        if (documenttypeChecklistList != null) {
            documenttypeChecklistList.on('afterAdd', me.onChecklistAdded);
        }
    },

    onChecklistAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        e.item.Mandatory(true);
    }

});